<app-scrollable-dialog headerKey="context.whatsNew">
  <ng-container content>
    <ng-container *ngIf="lastVersion as v">
      <mat-expansion-panel class="version-panel" [expanded]="true">
        <mat-expansion-panel-header [class.major]="v.major">
          <mat-panel-title>
            <h2>
              <div>{{ v.number }}</div>
              <div>{{ v.date | lDate: 'dShort' }}</div>
            </h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="version-description font-14" [innerHTML]="v.description"></div>
      </mat-expansion-panel>
    </ng-container>
  </ng-container>
  <ng-container actions>
    <app-icon-button icon="read_more" routerLink="/help/updates" [mat-dialog-close]="">
      {{ 'context.showAllHistory' | loc }}
    </app-icon-button>
  </ng-container>
</app-scrollable-dialog>
